<template>
  <v-container fluid grid-list-md>
    <v-layout column>
      <v-flex xs12>
        <v-card>
          <div class="flex xs12 page-header">Frequently Asked Questions</div>
          <v-container fluid grid-list-md class="faq-container">
            <v-layout row wrap>
              <v-flex xs12
                v-for="(item, idx) in FAQ"
                :key="idx"
                class="pa-2"
              >
                <div class="question">{{item.question}}</div>
                <v-card class="faq-card">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="pb-0">
                          <v-flex xs12 class="body">
                            <div class="faq-description">
                              <span v-html=item.answer></span>
                            </div>
                          </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'FAQ',
  data: () => ({
    FAQ: [
      { question: 'What is RecallFind.com?', answer: 'This site is meant to provide an easy way to find product recalls in an aesthetically pleasing format.  It primarily displays recalls reported by the <a href="https://www.cpsc.gov/" target="_blank" rel="noopener noreferrer">Consumer Product Safety Commission (CPSC)</a>' },
      { question: 'Is this a comprehensive list of recalls?', answer: 'No.  The product recalls shown are only recalls that are reported by the <a href="https://www.cpsc.gov/" target="_blank" rel="noopener noreferrer">Consumer Product Safety Commission (CPSC)</a>.  This is just one goverment agency that focuses on consumer safety, but there are many other government agencies that report recalls (Food, Drug, Vehicles, etc.) separately.' },
      { question: 'What about the "Other Agencies" section?', answer: 'These are simply feeds provided by the <a href="https://www.fda.gov/" target="_blank" rel="noopener noreferrer"Food & Drug Administration (FDA)></a> and <a href="https://www.nhtsa.gov/" target="_blank" rel="noopener noreferrer">National Highway Traffic Safety Administration (NHTSA)</a>.  They provide much less information and are not fomatted as nicely.  We hope to consolidate these into one consistent format in future versions of RecallFind. ' }

    ]
  })
}
</script>

<style lang="scss" scoped>
  .faq-container {
    text-align: left;

    .question {
      font-size: 1.25rem;
      font-weight: 700;
      line-height: 1.5rem;
      padding-bottom: 10px;
    }

    .faq-card {
      margin-bottom: 24px;

      .faq-description {
        text-align: left;
      }
    }

  }
</style>
